import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Link, useLocation } from 'react-router';
import { I18n } from 'utils/i18n';

const OtaAdminTabs = () => {
  const { pathname } = useLocation();
  const tab = pathname.includes('/home/admin/ota/updates') ? 'updates' : 'channels';

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        flexShrink: 0,
      }}
    >
      <Tabs
        value={tab}
        indicatorColor="primary"
        textColor="primary"
        sx={{
          minHeight: 48,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontSize: 14,
            fontWeight: 500,
            minHeight: 48,
          },
        }}
      >
        <Tab
          component={Link}
          to="/home/admin/ota/channels"
          value="channels"
          label={I18n.t('AdminOtaScene.tabs.channels')}
        />
        <Tab
          component={Link}
          to="/home/admin/ota/updates"
          value="updates"
          label={I18n.t('AdminOtaScene.tabs.updates')}
        />
      </Tabs>
    </Box>
  );
};

export default OtaAdminTabs;
